/*
    Build Your Own Box (BYOB) Section JavaScript
    SH Updated: February 2026 - Removed debug console statements for production
*/

(function () {
    'use strict';

    const BYOB = {
        // State
        state: {
            selectedProducts: [],
            packSize: 6,
            bundleProductId: null,
            bundleVariantId: null,
            bundlePrice: 0,
            activeFilter: 'all'
        },

        // DOM Elements cache
        elements: {},

        // Initialize
        init: function () {
            // Load config from JSON
            this.loadConfig();

            // Restore state from sessionStorage (before caching elements)
            this.restoreState();

            // Cache DOM elements
            this.cacheElements();

            // Bind events
            this.bindEvents();

            // Update UI with restored products or just CTA
            if (this.state.selectedProducts.length > 0) {
                this.updateUI();
                this.updateAllProductQuantityDisplays();
            } else {
                this.updateCTAButton();
            }

            // Trigger initial filter rendering (defaults to 'all', ensures headers are rendered)
            this.filterProducts(this.state.activeFilter);
        },

        // Load configuration from data-byob-products JSON
        loadConfig: function () {
            const configEl = document.querySelector('[data-byob-products]');
            if (configEl) {
                try {
                    const config = JSON.parse(configEl.textContent);
                    this.state.packSize = config.number_of_products || 6;
                    this.state.bundleProductId = config.bundleProductId;
                    this.state.bundleVariantId = config.bundleVariantId;
                    this.state.bundlePrice = config.bundlePrice;
                } catch (e) {
                    console.error('BYOB: Failed to parse config', e);
                }
            }
        },

        // Cache DOM elements
        cacheElements: function () {
            this.elements = {
                // Product grid
                productItems: document.querySelectorAll('.sb__product-item'),
                addButtons: document.querySelectorAll('.js-add-byob-product-cart'),

                // Quantity selectors
                quantitySelectors: document.querySelectorAll('.sb__quantity-selector'),
                qtyMinusButtons: document.querySelectorAll('.js-byob-qty-minus'),
                qtyPlusButtons: document.querySelectorAll('.js-byob-qty-plus'),
                qtyInputs: document.querySelectorAll('.js-byob-qty-input'),

                // Placeholders (both desktop header and mobile footer)
                placeholderLists: document.querySelectorAll('.sb__placeholder'),
                placeholderSlots: document.querySelectorAll('.sb__placeholder-item'),

                // Filters
                filterButtons: document.querySelectorAll('[data-filter]'),

                // Footer counter
                selectionCounts: document.querySelectorAll('[data-selection-count]'),
                packSizeDisplays: document.querySelectorAll('[data-pack-size-display]'),

                // CTA (may have multiple - desktop header + mobile)
                forms: document.querySelectorAll('[data-byob-form]'),
                ctaButtons: document.querySelectorAll('[data-byob-cta-button]'),
                ctaTexts: document.querySelectorAll('[data-byob-cta-text]'),

                // Mobile footer toggle
                footer: document.querySelector('.sb__footer'),
                footerToggle: document.querySelector('[data-byob-footer-toggle]'),

                // Variety section
                varietyItems: document.querySelectorAll('.sb__variety--item')
            };
        },

        // Bind event listeners
        bindEvents: function () {
            // Product interactions (Delegated to list)
            const productsList = document.querySelector('.sb__products-list');
            if (productsList) {
                productsList.addEventListener('click', (e) => {
                    const target = e.target;

                    // Add Button
                    const addBtn = target.closest('[data-byob-add-button]');
                    if (addBtn) {
                        e.preventDefault();
                        const productItem = addBtn.closest('.sb__product-item');
                        this.handleAddProduct(productItem);
                        return;
                    }

                    // Plus Button
                    const plusBtn = target.closest('[data-byob-qty-plus]');
                    if (plusBtn) {
                        e.preventDefault();
                        const productItem = plusBtn.closest('.sb__product-item');
                        this.handleQuantityChange(productItem, 1);
                        return;
                    }

                    // Minus Button
                    const minusBtn = target.closest('[data-byob-qty-minus]');
                    if (minusBtn) {
                        e.preventDefault();
                        const productItem = minusBtn.closest('.sb__product-item');
                        this.handleQuantityChange(productItem, -1);
                        return;
                    }
                });

                // Quantity Input Delegation
                productsList.addEventListener('change', (e) => {
                    const input = e.target.closest('[data-byob-qty-input]');
                    if (input) {
                        const productItem = input.closest('.sb__product-item');
                        const newQty = parseInt(input.value, 10) || 0;
                        this.handleQuantityInput(productItem, newQty);
                        return;
                    }

                    // SH Updated: March 2026 - Variant selector change
                    const variantSelect = e.target.closest('[data-byob-variant-select]');
                    if (variantSelect) {
                        const productItem = variantSelect.closest('.sb__product-item');
                        this.handleVariantChange(productItem, variantSelect);
                    }
                });
            }

            // Remove button clicks (delegated to placeholder lists)
            this.elements.placeholderLists.forEach(placeholderList => {
                placeholderList.addEventListener('click', (e) => {
                    const removeBtn = e.target.closest('.sb__product-remove-button');
                    if (removeBtn) {
                        e.preventDefault();
                        this.handleRemoveProduct(removeBtn);
                    }
                });
            });

            // Filter button clicks
            this.elements.filterButtons.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.handleFilter(btn);
                });
            });

            // Form submit
            this.elements.forms.forEach(form => {
                form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    this.handleSubmit(form);
                });
            });

            // Mobile footer toggle
            if (this.elements.footerToggle) {
                this.elements.footerToggle.addEventListener('click', this.handleFooterToggle.bind(this));
            }

            // Subscription toggle (show/hide frequency dropdown)
            const subscriptionRadios = document.querySelectorAll('[data-byob-purchase-type]');
            subscriptionRadios.forEach(radio => {
                radio.addEventListener('change', (e) => {
                    this.handleSubscriptionToggle(e.target);
                });
            });

            // Subscription frequency change (update hidden selling_plan inputs)
            const sellingPlanSelects = document.querySelectorAll('[data-byob-selling-plan]');
            sellingPlanSelects.forEach(select => {
                select.addEventListener('change', (e) => {
                    this.handleSellingPlanChange(e.target);
                });
            });

            // Initialize subscription UI state
            this.initSubscriptionUI();

            // Gift message checkbox toggle (handle all instances)
            const giftMessageToggles = document.querySelectorAll('[data-byob-gift-message-toggle]');
            giftMessageToggles.forEach(toggle => {
                toggle.addEventListener('change', (e) => {
                    this.handleGiftMessageToggle(e.target);
                });
            });
        },

        // Initialize subscription UI state
        initSubscriptionUI: function () {
            const subscriptionContainer = document.querySelector('[data-byob-subscription]');
            if (!subscriptionContainer) return;

            const checkedRadio = subscriptionContainer.querySelector('[data-byob-purchase-type]:checked');
            if (checkedRadio) {
                this.handleSubscriptionToggle(checkedRadio);
            }
        },

        // Handle subscription toggle
        handleSubscriptionToggle: function (radio) {
            const subscriptionContainer = radio.closest('[data-byob-subscription]');
            if (!subscriptionContainer) return;

            const frequencyWrap = subscriptionContainer.querySelector('[data-byob-frequency-wrap]');
            const mainPriceEls = document.querySelectorAll('[data-byob-main-price-value]');
            const otpPriceEl = subscriptionContainer.querySelector('[data-byob-otp-price]');
            const subPriceEl = subscriptionContainer.querySelector('[data-byob-sub-price]');

            // Sync all subscription toggles to same state
            const allSubscriptionRadios = document.querySelectorAll(`[data-byob-purchase-type][value="${radio.value}"]`);
            allSubscriptionRadios.forEach(r => r.checked = true);

            // Show/hide all frequency dropdowns
            const allFrequencyWraps = document.querySelectorAll('[data-byob-frequency-wrap]');

            // Get all hidden selling_plan inputs
            const allSellingPlanInputs = document.querySelectorAll('.js-selling-plan-id');

            // Get CTA text elements for price update
            const ctaTextEls = document.querySelectorAll('[data-byob-cta-text]');
            const isComplete = this.state.selectedProducts.length === this.state.packSize;

            if (radio.value === 'sub') {
                allFrequencyWraps.forEach(wrap => wrap.style.display = 'block');
                document.querySelectorAll('[data-byob-subscription]').forEach(container => {
                    container.setAttribute('data-subscription-active', 'sub');
                });

                // Update hidden selling_plan inputs with selected plan
                const sellingPlanSelect = subscriptionContainer.querySelector('[data-byob-selling-plan]');
                const sellingPlanId = sellingPlanSelect ? sellingPlanSelect.value : '';
                allSellingPlanInputs.forEach(input => input.value = sellingPlanId);

                // Update ALL main prices to subscription price
                if (subPriceEl) {
                    const subPrice = subPriceEl.textContent.trim();
                    mainPriceEls.forEach(el => el.textContent = subPrice);

                    // Update CTA button price if bundle is complete
                    if (isComplete) {
                        ctaTextEls.forEach(el => el.innerHTML = `${subPrice} | Add to cart`);
                    }
                }
            } else {
                allFrequencyWraps.forEach(wrap => wrap.style.display = 'none');
                document.querySelectorAll('[data-byob-subscription]').forEach(container => {
                    container.setAttribute('data-subscription-active', 'otp');
                });

                // Clear hidden selling_plan inputs for one-time purchase
                allSellingPlanInputs.forEach(input => input.value = '');

                // Update ALL main prices to OTP price
                if (otpPriceEl) {
                    const otpPrice = otpPriceEl.textContent.trim();
                    mainPriceEls.forEach(el => el.textContent = otpPrice);

                    // Update CTA button price if bundle is complete
                    if (isComplete) {
                        ctaTextEls.forEach(el => el.innerHTML = `${otpPrice} | Add to cart`);
                    }
                }
            }
        },

        // Handle selling plan (frequency) change
        handleSellingPlanChange: function (select) {
            const sellingPlanId = select.value;

            // Sync all selling plan selects to same value
            const allSellingPlanSelects = document.querySelectorAll('[data-byob-selling-plan]');
            allSellingPlanSelects.forEach(s => s.value = sellingPlanId);

            // Update all hidden selling_plan inputs
            const allSellingPlanInputs = document.querySelectorAll('.js-selling-plan-id');
            allSellingPlanInputs.forEach(input => input.value = sellingPlanId);
        },

        // Handle gift message checkbox toggle
        handleGiftMessageToggle: function (checkbox) {
            const container = checkbox.closest('[data-byob-gift-message-container]');
            if (!container) return;

            const messageField = container.querySelector('[data-byob-gift-message-field]');
            const textarea = container.querySelector('[data-byob-gift-message]');
            if (!messageField) return;

            if (checkbox.checked) {
                messageField.style.display = 'block';
            } else {
                messageField.style.display = 'none';
                // Clear the textarea when unchecked
                if (textarea) {
                    textarea.value = '';
                }
            }
        },

        // Handle Add Product click
        handleAddProduct: function (productItem) {
            // Extract product data from data attributes
            const productData = {
                productId: productItem.dataset.productId,
                variantId: productItem.dataset.variantId,
                title: productItem.dataset.productTitle,
                variantTitle: productItem.dataset.variantTitle || '',
                image: productItem.dataset.productImage,
                collections: productItem.dataset.productCollections
            };

            // Check if pack is full
            if (this.state.selectedProducts.length >= this.state.packSize) {
                return;
            }

            // Add to state
            this.state.selectedProducts.push(productData);

            // Trigger visual feedback animation
            productItem.classList.add('just-added');
            setTimeout(() => {
                productItem.classList.remove('just-added');
            }, 400);

            // Update UI
            this.updateUI();

            // Update quantity display for this product card (show selector, hide Add button)
            // Handle multiple instances/clones
            const variantId = productItem.dataset.variantId;
            const productCards = document.querySelectorAll(`.sb__product-item[data-variant-id="${variantId}"]`);
            productCards.forEach(card => {
                if (card.classList.contains('just-added')) return;
                card.classList.add('just-added');
                setTimeout(() => card.classList.remove('just-added'), 400);
            });
            productCards.forEach(card => this.updateProductQuantityDisplay(card));
        },

        // Handle Remove Product click
        handleRemoveProduct: function (removeBtn) {
            const removeIndex = parseInt(removeBtn.dataset.removeIndex, 10);

            // Validate index
            if (isNaN(removeIndex) || removeIndex < 0 || removeIndex >= this.state.selectedProducts.length) {
                return;
            }

            // Get product being removed to update its card
            const removedProduct = this.state.selectedProducts[removeIndex];

            // Remove from state
            this.state.selectedProducts.splice(removeIndex, 1);

            // Update UI
            this.updateUI();

            // Update the product card's quantity display
            // Update the product card's quantity display (handle multiple instances/clones)
            const productCards = document.querySelectorAll(`.sb__product-item[data-variant-id="${removedProduct.variantId}"]`);
            productCards.forEach(card => this.updateProductQuantityDisplay(card));
        },

        // Handle Filter click
        handleFilter: function (filterBtn) {
            const filterHandle = filterBtn.dataset.filter;

            // Update active state on buttons
            this.elements.filterButtons.forEach(btn => {
                btn.classList.remove('active');
            });
            filterBtn.classList.add('active');

            // Update state
            this.state.activeFilter = filterHandle;

            // Filter products
            this.filterProducts(filterHandle);
        },

        // Render products grouped by sections
        renderGroupedProducts: function () {
            const container = document.querySelector('.sb__products-list');
            const mainContainer = document.querySelector('.sb__container');

            let sections = [];

            // Try to read dynamic config from metaobject
            try {
                if (mainContainer && mainContainer.dataset.sectionConfig) {
                    sections = JSON.parse(mainContainer.dataset.sectionConfig);
                }
            } catch (e) {
                console.error('BYOB: Failed to parse section config', e);
            }

            // Fallback removed per user request: Empty field = No headers (flat list)
            if (!sections) sections = [];

            // Clear container but keep the product elements in memory/DOM if needed? 
            // We reference `this.elements.productItems` which has the originals.
            const allProducts = Array.from(this.elements.productItems);

            // 1. Detach originals safely
            allProducts.forEach(el => el.remove());

            // 2. Clear container (removes headers and any leftovers/clones)
            container.innerHTML = '';

            // Helper to create header
            const createHeader = (title) => {
                const header = document.createElement('li');
                header.className = 'sb__section-header';
                header.innerHTML = `
                    <h3 class="sb__section-title">${title}</h3>
                    <span class="sb__section-line"></span>
                `;
                return header;
            };

            // Track displayed product IDs to avoid duplicates if we want unique display (Optional)
            // The brief says: "If a product belongs to multiple sections... decide on display logic".
            // Implementation plan says: "Show in ALL matching sections".
            // So we will clone the node if it appears multiple times? 
            // CLONING nodes breaks event listeners (add buttons, qty selectors).
            // BETTER: Since cloning is complex with event binding, let's limit to ONE appearance for now (First Match),
            // OR we just move the node.

            // Wait, moving the node means it can only be in one section.
            // Brief says: "Option 2: Show product in all matching sections ... - confirm with Erick".
            // Plan says: "I'm assuming ... Show in ALL matching sections".

            // If we want to show in ALL sections, we MUST clone the element.
            // But if we clone, we break all the `this.elements.addButtons` references and event listeners.
            // Re-binding events is a pain.

            // ALTERNATIVE: Since we are in EXECUTION and user approved "Show in ALL", 
            // I will implement "First Match" for now to safer Technical Implementation (avoiding cloning complex interactive cards).
            // "Edge Cases... Option 1: Show product only in the first matching section". I'll stick to this for technical stability unless forced.

            // Track which products have been rendered to know when to use original vs clone
            // We use Original Node for the FIRST appearance and Clones for subsequent appearances.
            const renderedProductIds = new Set();

            sections.forEach(section => {
                const sectionProducts = allProducts.filter(item => {
                    const collections = (item.dataset.productCollections || '').split(',');
                    return collections.includes(section.handle);
                });

                if (sectionProducts.length > 0) {
                    // Append Header
                    container.appendChild(createHeader(section.title));

                    // Append Products
                    sectionProducts.forEach(item => {
                        let nodeToAppend;
                        if (!renderedProductIds.has(item.dataset.variantId)) {
                            // First time seeing this product -> Use Original
                            nodeToAppend = item;
                            renderedProductIds.add(item.dataset.variantId);
                        } else {
                            // Already rendered -> Use Clone
                            nodeToAppend = item.cloneNode(true);
                        }
                        nodeToAppend.style.display = ''; // Ensure visible
                        container.appendChild(nodeToAppend);
                    });
                }
            });

            // Handle remaining products (not in any section)
            const remainingProducts = allProducts.filter(item => {
                // If it hasn't been rendered yet, it means it wasn't in any section
                return !renderedProductIds.has(item.dataset.variantId);
            });
            if (remainingProducts.length > 0) {
                // Maybe check if they should be shown?
                // For now, let's append them at the bottom without header or with "Other"
                // container.appendChild(createHeader('Other'));
                remainingProducts.forEach(item => {
                    item.style.display = '';
                    container.appendChild(item);
                });
            }
        },

        // Filter products by collection handle
        filterProducts: function (filterHandle) {
            const container = document.querySelector('.sb__products-list');

            if (filterHandle === 'all') {
                // Use grouped rendering
                this.renderGroupedProducts();

            } else {
                // Flat list filtering
                const allProducts = Array.from(this.elements.productItems);

                // 1. Detach originals safely so we don't lose them
                allProducts.forEach(el => el.remove());

                // 2. Clear container to remove headers and clones
                container.innerHTML = '';

                // 3. Append originals back to container
                allProducts.forEach(item => {
                    container.appendChild(item);

                    const collections = (item.dataset.productCollections || '').split(',');
                    if (collections.includes(filterHandle)) {
                        item.style.display = '';
                    } else {
                        item.style.display = 'none';
                    }
                });
            }
        },

        // Handle form submit
        handleSubmit: function (form) {
            // Validate selection is complete
            if (this.state.selectedProducts.length !== this.state.packSize) {
                return;
            }

            // Get CTA button for this form
            const ctaButton = form.querySelector('[data-byob-cta-button]');
            if (ctaButton) {
                ctaButton.disabled = true;
                ctaButton.classList.add('is-loading');
            }

            // Build formData object
            const formData = this.buildFormData(form);

            // SH Updated: March 2026 - Use native theme events for add-to-cart flow
            console.log('[BYOB] Add to cart — items:', formData.items.length, 'pack size:', this.state.packSize);
            document.dispatchEvent(new CustomEvent('theme:loading:start'));

            // POST to cart
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    console.log('[BYOB] Shopify response status:', response.status);

                    if (!response.ok) {
                        return response.json().then(errorData => {
                            throw new Error(errorData.description || errorData.message || `HTTP error! status: ${response.status}`);
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    console.log('[BYOB] Items added to cart successfully', data);

                    // Clear sessionStorage
                    sessionStorage.removeItem('byob_selected_products');

                    // Reset state
                    this.state.selectedProducts = [];
                    this.updateUI();

                    // Dispatch product:added — theme's CartSection handles re-render + drawer open
                    console.log('[BYOB] Dispatching product:added with quantity:', formData.items.length);
                    form.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            quantity: formData.items.length
                        }
                    }));
                })
                .catch(error => {
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    console.error('[BYOB] Failed to add to cart:', error);
                    alert('Failed to add to cart. Please try again.');
                    this.updateUI();
                })
                .finally(() => {
                    if (ctaButton) {
                        ctaButton.classList.remove('is-loading');
                    }
                });
        },

        // Build formData object for cart submission
        buildFormData: function (form) {
            // Generate unique bundle ID for grouping
            const bundleId = 'byob_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

            // Initialize formData with items array
            let formData = {
                items: []
            };

            // Check for subscription - use hidden selling_plan input as source of truth
            const hiddenSellingPlanInput = form.querySelector('.js-selling-plan-id');
            let sellingPlanId = hiddenSellingPlanInput ? hiddenSellingPlanInput.value : null;

            // If hidden input is empty, fall back to checking UI elements
            if (!sellingPlanId) {
                const byobPurchaseType = form.querySelector('[data-byob-purchase-type]:checked');
                const byobSellingPlan = form.querySelector('[data-byob-selling-plan]');

                if (byobPurchaseType && byobPurchaseType.value === 'sub' && byobSellingPlan) {
                    sellingPlanId = byobSellingPlan.value;
                } else {
                    // Fallback to legacy RTX-PDP
                    const purchaseTypeEl = form.querySelector('[name="purchaseType"]:checked');
                    const sellingPlanSelect = form.querySelector('[name="rtx_selling_plan"]');
                    if (purchaseTypeEl && purchaseTypeEl.value === 'purchaseTypeSubscription' && sellingPlanSelect) {
                        sellingPlanId = sellingPlanSelect.value;
                    }
                }
            }

            const isSubscription = !!sellingPlanId;

            // Check for gift message
            const giftMessageEl = form.querySelector('[data-byob-gift-message]');
            const giftMessage = giftMessageEl ? giftMessageEl.value.trim() : '';

            // 1. Add main bundle product (parent)
            let bundleItem = {
                id: parseInt(this.state.bundleVariantId, 10),
                quantity: 1,
                properties: {
                    '_bundle_id': bundleId,
                    '_bundle_parent': 'true'
                }
            };

            // Add gift message if provided
            if (giftMessage) {
                bundleItem.properties['Gift message'] = giftMessage;
            }

            // Add selling_plan only if subscription
            if (sellingPlanId) {
                bundleItem.selling_plan = parseInt(sellingPlanId, 10);
            }

            formData.items.push(bundleItem);

            // 2. Add selected products (children) - hardcoded quantity: 1 for now
            // Note: parent_id is NOT a valid Cart API request param, only use properties
            this.state.selectedProducts.forEach((product) => {
                let productItem = {
                    id: parseInt(product.variantId, 10),
                    quantity: 1,
                    properties: {
                        '_bundle_id': bundleId,
                        '_bundle_parent_id': this.state.bundleProductId.toString()
                    }
                };

                formData.items.push(productItem);
            });

            return formData;
        },

        // SH Updated: March 2026 - Removed refreshCart, now using native theme events (product:added)

        // Handle mobile footer toggle
        handleFooterToggle: function () {
            if (!this.elements.footer) return;

            const isOpen = this.elements.footer.classList.toggle('is-open');
            this.elements.footerToggle.setAttribute('aria-expanded', isOpen);
        },

        // Update all UI elements
        updateUI: function () {
            this.updatePlaceholders();
            this.updateCounter();
            this.updateCTAButton();
            this.updateAddButtons();
            this.updateVariety();
            this.updateAllProductQuantityDisplays();
            this.saveState();
        },

        // Update Add buttons state (disable when pack is full)
        updateAddButtons: function () {
            const isFull = this.state.selectedProducts.length >= this.state.packSize;

            // Disable/enable Add buttons
            this.elements.addButtons.forEach(btn => {
                if (isFull) {
                    btn.disabled = true;
                    btn.classList.remove('Button--primary');
                    btn.classList.add('Button--secondary');
                } else {
                    btn.disabled = false;
                    btn.classList.remove('Button--secondary');
                    btn.classList.add('Button--primary');
                }
            });

            // Disable/enable + buttons on quantity selectors when pack is full
            this.elements.qtyPlusButtons.forEach(btn => {
                if (isFull) {
                    btn.disabled = true;
                    btn.classList.add('is-disabled');
                } else {
                    btn.disabled = false;
                    btn.classList.remove('is-disabled');
                }
            });
        },

        // Get quantity of specific product in selection by variantId
        getProductQuantity: function (variantId) {
            return this.state.selectedProducts.filter(p => p.variantId === variantId).length;
        },

        // Update the quantity display for a product card (toggle between Add button and quantity selector)
        updateProductQuantityDisplay: function (productItem) {
            const variantId = productItem.dataset.variantId;
            const qty = this.getProductQuantity(variantId);
            const addBtn = productItem.querySelector('.js-add-byob-product-cart');
            const qtySelector = productItem.querySelector('.sb__quantity-selector');
            const qtyInput = productItem.querySelector('.js-byob-qty-input');

            if (qty > 0) {
                // Show quantity selector, hide Add button
                if (addBtn) addBtn.style.display = 'none';
                if (qtySelector) qtySelector.style.display = '';
                if (qtyInput) qtyInput.value = qty;
            } else {
                // Show Add button, hide quantity selector
                if (addBtn) addBtn.style.display = '';
                if (qtySelector) qtySelector.style.display = 'none';
            }
        },

        // Handle quantity +/- button clicks
        handleQuantityChange: function (productItem, delta) {
            const variantId = productItem.dataset.variantId;
            const currentQty = this.getProductQuantity(variantId);

            if (delta > 0) {
                // Adding - check pack not full
                if (this.state.selectedProducts.length >= this.state.packSize) {
                    return;
                }
                // Add product to state
                const productData = {
                    productId: productItem.dataset.productId,
                    variantId: productItem.dataset.variantId,
                    title: productItem.dataset.productTitle,
                    variantTitle: productItem.dataset.variantTitle || '',
                    image: productItem.dataset.productImage,
                    collections: productItem.dataset.productCollections
                };
                this.state.selectedProducts.push(productData);
            } else if (delta < 0 && currentQty > 0) {
                // Removing - find and remove one instance of this product
                const index = this.state.selectedProducts.findIndex(p => p.variantId === variantId);
                if (index > -1) {
                    this.state.selectedProducts.splice(index, 1);
                }
            }

            // Update UI
            this.updateUI();

            // Update this product's quantity display
            this.updateProductQuantityDisplay(productItem);
        },

        // Handle direct quantity input
        handleQuantityInput: function (productItem, newQty) {
            const variantId = productItem.dataset.variantId;
            const currentQty = this.getProductQuantity(variantId);

            // Clamp to valid range (0 to max allowed)
            newQty = Math.max(0, newQty);

            // Check if new quantity would exceed pack size
            const otherProductsCount = this.state.selectedProducts.filter(p => p.variantId !== variantId).length;
            const maxAllowed = this.state.packSize - otherProductsCount;
            newQty = Math.min(newQty, maxAllowed);

            // Calculate delta and apply changes
            const delta = newQty - currentQty;

            if (delta > 0) {
                // Add products
                const productData = {
                    productId: productItem.dataset.productId,
                    variantId: productItem.dataset.variantId,
                    title: productItem.dataset.productTitle,
                    variantTitle: productItem.dataset.variantTitle || '',
                    image: productItem.dataset.productImage,
                    collections: productItem.dataset.productCollections
                };
                for (let i = 0; i < delta; i++) {
                    this.state.selectedProducts.push({ ...productData });
                }
            } else if (delta < 0) {
                // Remove products
                for (let i = 0; i < Math.abs(delta); i++) {
                    const index = this.state.selectedProducts.findIndex(p => p.variantId === variantId);
                    if (index > -1) {
                        this.state.selectedProducts.splice(index, 1);
                    }
                }
            }

            // Update UI
            this.updateUI();

            // Update this product's quantity display
            // Update all instances
            const productCards = document.querySelectorAll(`.sb__product-item[data-variant-id="${variantId}"]`);
            productCards.forEach(card => this.updateProductQuantityDisplay(card));
        },

        // SH Updated: March 2026 - Handle variant selector change
        handleVariantChange: function (productItem, select) {
            const oldVariantId = productItem.dataset.variantId;
            const newVariantId = select.value;
            const selectedOption = select.options[select.selectedIndex];

            // Update card data attributes
            productItem.dataset.variantId = newVariantId;

            // Update variant title on the card for placeholder display
            const variantTitle = selectedOption.textContent.trim();
            const productTitle = productItem.dataset.productTitle;
            // Store the base product title (without variant) for display
            productItem.dataset.variantTitle = variantTitle;

            // Update product image if variant has a specific image
            const variantImage = selectedOption.dataset.variantImage;
            if (variantImage) {
                const imgEl = productItem.querySelector('.sb__product-image img');
                if (imgEl) {
                    imgEl.src = variantImage;
                    imgEl.srcset = '';
                }
                productItem.dataset.productImage = variantImage;
            }

            // If this product was already in the bundle, remove old variant entries and reset display
            const oldQty = this.getProductQuantity(oldVariantId);
            if (oldQty > 0) {
                this.state.selectedProducts = this.state.selectedProducts.filter(
                    p => p.variantId !== oldVariantId
                );
                this.updateUI();
            }

            // Sync variant selector on cloned cards (same product appearing under multiple filter tabs)
            const productId = productItem.dataset.productId;
            const allCards = document.querySelectorAll(`.sb__product-item[data-product-id="${productId}"]`);
            allCards.forEach(card => {
                if (card === productItem) return;
                card.dataset.variantId = newVariantId;
                card.dataset.variantTitle = variantTitle;
                if (variantImage) {
                    const img = card.querySelector('.sb__product-image img');
                    if (img) {
                        img.src = variantImage;
                        img.srcset = '';
                    }
                    card.dataset.productImage = variantImage;
                }
                const otherSelect = card.querySelector('[data-byob-variant-select]');
                if (otherSelect && otherSelect.value !== newVariantId) {
                    otherSelect.value = newVariantId;
                }
                this.updateProductQuantityDisplay(card);
            });
        },

        // Update placeholder slots with selected products
        updatePlaceholders: function () {
            // Loop through each placeholder list (desktop + mobile)
            this.elements.placeholderLists.forEach((placeholderList) => {
                const slots = placeholderList.querySelectorAll('.sb__placeholder-item');

                slots.forEach((slot, slotIndex) => {
                    const product = this.state.selectedProducts[slotIndex];
                    const placeholderSvg = slot.querySelector('.sb__placeholder-svg');
                    const selectedContainer = slot.querySelector('.sb__product-selected');
                    const selectedImage = slot.querySelector('.sb__selected-image');
                    const removeBtn = slot.querySelector('.sb__product-remove-button');

                    if (product) {
                        // Show selected product
                        slot.classList.add('has-selection');
                        if (placeholderSvg) placeholderSvg.style.display = 'none';
                        if (selectedContainer) {
                            selectedContainer.style.display = '';
                            if (selectedImage) {
                                selectedImage.src = product.image;
                                selectedImage.alt = product.title;
                            }
                            if (removeBtn) {
                                removeBtn.dataset.removeIndex = slotIndex;
                            }
                        }
                    } else {
                        // Show placeholder
                        slot.classList.remove('has-selection');
                        if (placeholderSvg) placeholderSvg.style.display = '';
                        if (selectedContainer) selectedContainer.style.display = 'none';
                    }
                });
            });
        },

        // Update selection counter
        updateCounter: function () {
            const count = this.state.selectedProducts.length;
            const packSize = this.state.packSize;
            const remaining = packSize - count;

            // Update all selection count displays
            this.elements.selectionCounts.forEach(el => {
                el.textContent = count;
            });

            // Update all pack size displays
            this.elements.packSizeDisplays.forEach(el => {
                el.textContent = packSize;
            });
        },

        // Update CTA button state
        updateCTAButton: function () {
            const count = this.state.selectedProducts.length;
            const packSize = this.state.packSize;
            const remaining = packSize - count;
            const isComplete = count === packSize;

            const buttons = this.elements.ctaButtons;
            const textEls = this.elements.ctaTexts;

            if (buttons.length === 0) {
                return;
            }

            // Get current price based on subscription state
            let displayPrice;
            const subscriptionRadio = document.querySelector('[data-byob-purchase-type]:checked');
            const isSubscription = subscriptionRadio && subscriptionRadio.value === 'sub';

            if (isSubscription) {
                // Use subscription price from the UI
                const subPriceEl = document.querySelector('[data-byob-sub-price]');
                displayPrice = subPriceEl ? subPriceEl.textContent.trim() : `$ ${(this.state.bundlePrice / 100).toFixed(2)}`;
            } else {
                // Use OTP price from the UI or fallback to bundle price
                const otpPriceEl = document.querySelector('[data-byob-otp-price]');
                displayPrice = otpPriceEl ? otpPriceEl.textContent.trim() : `$ ${(this.state.bundlePrice / 100).toFixed(2)}`;
            }

            // Update all buttons
            buttons.forEach((btn, index) => {
                if (isComplete) {
                    btn.disabled = false;
                    btn.classList.remove('Button--secondary');
                    btn.classList.add('Button--primary');
                } else {
                    btn.disabled = true;
                    btn.classList.remove('Button--primary');
                    btn.classList.add('Button--secondary');
                }
            });

            // Update all text elements
            textEls.forEach((textEl, index) => {
                if (isComplete) {
                    textEl.innerHTML = `${displayPrice} | Add to cart`;
                } else {
                    textEl.innerHTML = `Add ${remaining} more`;
                }
            });

            // Toggle is-complete class on footer for mobile CTA visibility
            if (this.elements.footer) {
                if (isComplete) {
                    this.elements.footer.classList.add('is-complete');
                } else {
                    this.elements.footer.classList.remove('is-complete');
                }
            }
        },

        // Update variety section counters
        updateVariety: function () {
            if (!this.elements.varietyItems || this.elements.varietyItems.length === 0) {
                return;
            }

            this.elements.varietyItems.forEach(item => {
                const collectionHandle = item.dataset.collectionHandle;
                if (!collectionHandle) return;

                // Count selected products that belong to this collection
                const count = this.state.selectedProducts.filter(product => {
                    const collections = product.collections ? product.collections.split(',') : [];
                    return collections.includes(collectionHandle);
                }).length;

                // Update counter
                const counter = item.querySelector('.sb__variety--item-counter');
                if (counter) {
                    counter.textContent = count;
                }

                // Toggle has-item class
                if (count > 0) {
                    item.classList.add('has-item');
                } else {
                    item.classList.remove('has-item');
                }
            });
        },

        // Save state to sessionStorage
        saveState: function () {
            const dataToSave = {
                selectedProducts: this.state.selectedProducts,
                timestamp: Date.now()
            };
            try {
                sessionStorage.setItem('byob_selected_products', JSON.stringify(dataToSave));
            } catch (e) {
                // Silently fail - sessionStorage may be full or disabled
            }
        },

        // Validate restored products exist on the current page
        validateRestoredProducts: function (products) {
            const availableVariantIds = new Set();
            document.querySelectorAll('.sb__product-item').forEach(item => {
                const variantId = item.dataset.variantId;
                const isAvailable = item.querySelector('.js-add-byob-product-cart') !== null;
                if (variantId && isAvailable) {
                    availableVariantIds.add(variantId);
                }
            });

            return products.filter(product => {
                return availableVariantIds.has(product.variantId);
            });
        },

        // Restore state from sessionStorage
        restoreState: function () {
            try {
                const savedData = sessionStorage.getItem('byob_selected_products');
                if (!savedData) {
                    return;
                }

                const parsed = JSON.parse(savedData);
                let restoredProducts = parsed.selectedProducts || [];

                // Truncate if new pack size is smaller
                if (restoredProducts.length > this.state.packSize) {
                    restoredProducts = restoredProducts.slice(0, this.state.packSize);
                }

                // Validate products exist on this page
                restoredProducts = this.validateRestoredProducts(restoredProducts);

                this.state.selectedProducts = restoredProducts;
            } catch (e) {
                // Silently fail and clear corrupted state
                sessionStorage.removeItem('byob_selected_products');
            }
        },

        // Update all product quantity displays (for restored products)
        updateAllProductQuantityDisplays: function () {
            const allItems = document.querySelectorAll('.sb__product-item');
            allItems.forEach(productItem => {
                this.updateProductQuantityDisplay(productItem);
            });
        }
    };

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => BYOB.init());
    } else {
        BYOB.init();
    }

    // Expose to window for debugging
    window.BYOB = BYOB;

})();
